import Lista from './Lista';

export const FuncaoLista = Lista;
